import {configQuery} from './api'

const costReg = /^-?\d{1,2}$/;

export const getGoodsVerifyConfig=async ()=>{
 const res=await configQuery({
  appId: "1002",
  keys: ["oms.order.check.sku.info"]
})
  if(res&&res.configs.length){
    return JSON.parse(res.configs[0].value)
  }
  return {}
}
// CP001模板
export const goodsTableDetils =
  [
    {
      title: '货主货品编码',
      dataIndex: 'skuCode',
      key: 'skuCode',
      width: 220
    },
    {
      title: '货品名称',
      dataIndex: 'skuName',
      key: 'skuName',
      width: 300
    },
    {
      slots: { title: 'numberTitle' },
      dataIndex: 'number',
      key: 'number',
      width: 160,
      scopedSlots: { customRender: 'number' },
    },
    {
      slots: { title: 'weightTitle' },
      dataIndex: 'weight',
      key: 'weight',
      width: 160,
      scopedSlots: { customRender: 'weight' },
    },
    {
      slots: { title: 'volumeTitle' },
      dataIndex: 'volume',
      key: 'volume',
      width: 160,
      scopedSlots: { customRender: 'volume' },
    },
    {
      slots: { title: 'temperatureZoneTitle' },
      dataIndex: 'temperatureZone',
      key: 'temperatureZone',
      scopedSlots: { customRender: 'temperatureZone' },
      width: 200
    },
    // {
    //   title: '操作',
    //   dataIndex: 'caozuo',
    //   key: 'caozuo',
    //   width: 160,
    //   fixed: 'right',
    //   scopedSlots: { customRender: 'caozuo' },
    // },
  ]

export const goodsTableCar =
  [
    {
      title: '货主货品编码',
      dataIndex: 'skuCode',
      key: 'skuCode',
      width: 220
    },
    {
      title: '货品名称',
      dataIndex: 'skuName',
      key: 'skuName',
      width: 300
    },
    {
      slots: { title: 'numberTitle' },
      dataIndex: 'number',
      key: 'number',
      width: 160,
      scopedSlots: { customRender: 'number' },
    },
    {
      slots: { title: 'weightTitle' },
      dataIndex: 'weight',
      key: 'weight',
      width: 160,
      scopedSlots: { customRender: 'weight' },
    },
    {
      slots: { title: 'volumeTitle' },
      dataIndex: 'volume',
      key: 'volume',
      width: 160,
      scopedSlots: { customRender: 'volume' },
    },
    {
      slots: { title: 'temperatureZoneTitle' },
      dataIndex: 'temperatureZone',
      key: 'temperatureZone',
      scopedSlots: { customRender: 'temperatureZone' },
      width: 200
    },
    // {
    //   title: '操作',
    //   dataIndex: 'caozuo',
    //   key: 'caozuo',
    //   width: 160,
    //   fixed: 'right',
    //   scopedSlots: { customRender: 'caozuo' },
    // },
  ]

export const goodsTableSopt =
  [
    {
      title: '货主货品编码',
      dataIndex: 'skuCode',
      key: 'skuCode',
      width: 220
    },
    {
      title: '货品名称',
      dataIndex: 'skuName',
      key: 'skuName',
      width: 300
    },
    {
      slots: { title: 'numberTitle' },
      dataIndex: 'number',
      key: 'number',
      width: 160,
      scopedSlots: { customRender: 'number' },
    },
    {
      slots: { title: 'weightTitle' },
      dataIndex: 'weight',
      key: 'weight',
      width: 160,
      scopedSlots: { customRender: 'weight' },
    },
    {
      slots: { title: 'volumeTitle' },
      dataIndex: 'volume',
      key: 'volume',
      width: 160,
      scopedSlots: { customRender: 'volume' },
    },
    {
      slots: { title: 'temperatureZoneTitle' },
      dataIndex: 'temperatureZone',
      key: 'temperatureZone',
      scopedSlots: { customRender: 'temperatureZone' },
      width: 200
    },
    // {
    //   title: '总货值(元)',
    //   dataIndex: 'goodsValue',
    //   key: 'goodsValue',
    //   width: 160,
    //   scopedSlots: { customRender: 'goodsValue' },
    // },
    // {
    //   title: '操作',
    //   dataIndex: 'caozuo',
    //   key: 'caozuo',
    //   width: 160,
    //   fixed: 'right',
    //   scopedSlots: { customRender: 'caozuo' },
    // },
  ]

export const goodsTableLine =
  [
    {
      title: '货主货品编码',
      dataIndex: 'skuCode',
      key: 'skuCode',
      width: 220
    },
    {
      title: '货品名称',
      dataIndex: 'skuName',
      key: 'skuName',
      width: 300
    },
    {
      slots: { title: 'numberTitle' },
      dataIndex: 'number',
      key: 'number',
      width: 160,
      scopedSlots: { customRender: 'number' },
    },
    {
      slots: { title: 'weightTitle' },
      dataIndex: 'weight',
      key: 'weight',
      width: 160,
      scopedSlots: { customRender: 'weight' },
    },
    {
      slots: { title: 'volumeTitle' },
      dataIndex: 'volume',
      key: 'volume',
      width: 160,
      scopedSlots: { customRender: 'volume' },
    },
    {
      slots: { title: 'temperatureZoneTitle' },
      dataIndex: 'temperatureZone',
      key: 'temperatureZone',
      scopedSlots: { customRender: 'temperatureZone' },
      width: 200
    },
    // {
    //   title: '总货值(元)',
    //   dataIndex: 'goodsValue',
    //   key: 'goodsValue',
    //   width: 160,
    //   scopedSlots: { customRender: 'goodsValue' },
    // },
    // {
    //   title: '操作',
    //   dataIndex: 'caozuo',
    //   key: 'caozuo',
    //   width: 160,
    //   fixed: 'right',
    //   scopedSlots: { customRender: 'caozuo' },
    // },
  ]

export const goodsPriceRules = {
  number: {
    RULES: [
      { required: true, message: '请输入数量', trigger: 'change' },
    ]
  },
  weight: {
    RULES: [
      { required: true, message: '请输入总重量', trigger: 'change' },
    ]
  },
  volume: {
    RULES: [
      { required: true, message: '请输入总体积', trigger: 'change' },
    ]
  },
  temperatureZone: {
    RULES: [
      { required: true, message: '请输入总体积', trigger: 'change' },
    ]
  },
}

export const goodsRules = {
  skuId: {
    RULES: [
      { required: true, message: '请选择货品品类', trigger: 'change' },
    ]
  },
  goodsLevel: {
    RULES: [
      { required: true, message: '请选择货品三级分类', trigger: 'change' },
    ]
  },
  skuUnit: {
    MAX_LENGTH: 30, // 最大长度
    RULES: [
    ]
  },
  number: {
    MAX_LENGTH: 30, // 最大长度
    RULES: [
      { required: true, message: '请输入数量', trigger: 'change' },
    ]
  },
  weight: {
    MAX_LENGTH: 30, // 最大长度
    RULES: [
      { required: true, message: '请输入总重量', trigger: 'change' },
    ]
  },
  volume: {
    MAX_LENGTH: 30, // 最大长度
    RULES: [
      { required: true, message: '请输入总体积', trigger: 'change' },
    ]
  },
  temperatureZone: {
    RULES: [
      { required: true, message: '请选择温区', trigger: 'change' },
    ]
  },
  lowtemp: {
    RULES: [
      { required: true, message: '请输入', trigger: 'change' },
      { type: 'number', message: '请输入数字', trigger: 'change' },
      { pattern: costReg, message: '范围为-99至99', trigger: 'change' },
    ]
  },
  hightemp: {
    RULES: [
      { required: true, message: '请输入', trigger: 'change' },
      { type: 'number', message: '请输入数字', trigger: 'change' },
      { pattern: costReg, message: '范围为-99至99', trigger: 'change' },
    ]
  },
  shipment: {
    RULES: [
      { required: true, message: '请选择货品发货地', trigger: 'change' },
    ]
  },
  goodsValue: {
    RULES: [
    ]
  },
}

export const goodsTableListColumns = [
  {
    title: '货主货品编码',
    dataIndex: 'skuCode',
    key: 'skuCode',
    scopedSlots: { customRender: 'skuCode' },
    width: 200,
    ellipsis: true,
  },
  {
    title: '货品名称',
    dataIndex: 'skuName',
    key: 'skuName',
    scopedSlots: { customRender: 'skuName' },
    width: 330,
    ellipsis: true,
  },
  {
    title: '货品基础规格',
    dataIndex: 'norms',
    key: 'norms',
    scopedSlots: { customRender: 'norms' },
    width: 180,
  },
  {
    title: '货品三级分类',
    dataIndex: 'joinGoodsLevels',
    key: 'joinGoodsLevels',
    width: 190,
    ellipsis: true,
  },
  {
    title: '货品整单位',
    dataIndex: 'unit',
    key: 'unit',
    scopedSlots: { customRender: 'unit' },
    width: 120,
  },
  {
    title: '整单位重量(kg)',
    dataIndex: 'weight',
    key: 'weight',
    scopedSlots: { customRender: 'weight' },
    width: 120,
  },
  {
    title: '整单位体积（m³）',
    dataIndex: 'volume',
    key: 'volume',
    scopedSlots: { customRender: 'volume' },
    width: 120,
  },
  {
    title: '温区',
    dataIndex: 'temperatureZone',
    key: 'temperatureZone',
    scopedSlots: { customRender: 'temperatureZone' },
    width: 320,
  },
  {
    title: '货品单件含税价（元）',
    dataIndex: 'goodsPrice',
    key: 'goodsPrice',
    scopedSlots: { customRender: 'goodsPrice' },
    width: 140,
  },
]


export const goodsTableType = [
  {
    slots: { title: 'goodsLevelTitle' },
    dataIndex: 'goodsLevel',
    key: 'goodsLevel',
    scopedSlots: { customRender: 'goodsLevel' },
    width: 200,
  },
  {
    title: '货品计量整单位',
    dataIndex: 'skuUnit',
    key: 'skuUnit',
    width: 120,
    scopedSlots: { customRender: 'skuUnit' },
  },
  {
    slots: { title: 'numberTitle' },
    dataIndex: 'number',
    key: 'number',
    width: 160,
    scopedSlots: { customRender: 'number' },
  },
  {
    slots: { title: 'weightTitle' },
    dataIndex: 'weight',
    key: 'weight',
    width: 240,
    scopedSlots: { customRender: 'weight' },
  },
  {
    slots: { title: 'volumeTitle' },
    dataIndex: 'volume',
    key: 'volume',
    width: 240,
    scopedSlots: { customRender: 'volume' },
  },
  {
    slots: { title: 'temperatureZoneTitle' },
    dataIndex: 'temperatureZone',
    key: 'temperatureZone',
    scopedSlots: { customRender: 'temperatureZone' },
    width: 320
  },
  // {
  //   title: '总货值(元)',
  //   dataIndex: 'goodsValue',
  //   key: 'goodsValue',
  //   scopedSlots: { customRender: 'goodsValue' },
  // },
  // {
  //   title: '操作',
  //   dataIndex: 'caozuo',
  //   key: 'caozuo',
  //   scopedSlots: { customRender: 'caozuo' },
  //   width: 150
  // },
]
